import { render, staticRenderFns } from "./RemedyDetail.vue?vue&type=template&id=0ecfa60a&scoped=true"
import script from "./RemedyDetail.vue?vue&type=script&lang=js"
export * from "./RemedyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecfa60a",
  null
  
)

export default component.exports